<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="bg_wrap">
      <topPiece></topPiece>
      <div class="partner_wrap container">
        <div v-for="(item, index) in list" :key="index">
          <titleConfig
            v-if="item.contacts.length > 0"
            :title="langSet == 'cn' ? item.name : item.name_en"
            :type="2"
          ></titleConfig>
          <div class="partner_list" v-if="item.contacts.length > 0">
            <contacts class="partner_item" :list="item.contacts"></contacts>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import topPiece from "@/components/topPiece.vue";
import contacts from "@/components/contacts.vue";
import { contactsList } from "@/api/api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
    topPiece,
    contacts,
  },
  data() {
    return {
      langSet: "",
      list: [],
      metaData: {}
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.getContactsList();
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getContactsList() {
      const res = await contactsList();
      this.list = res.data.lists;
    },
  },
};
</script>
<style lang="scss" scoped>
.partner_list {
  margin-bottom: 60px;
  .partner_item {
    width: 100%;
  }
}
@media only screen and (max-width: 767px) {
  .partner_list {
    margin-bottom: 1.15rem;
  }
}
</style>